import splitbee from "@splitbee/web";
import posthog from "posthog-js";
import { normalizeAnalyticsEvent } from "./normalizeAnalyticsEvent";

export type AnalyticsProperties = Record<string, string | number | boolean | null | undefined>;

const normalizeAndCapture = (rawEvent: string, properties: AnalyticsProperties = {}) => {
  const { event, properties: normalizedProperties } = normalizeAnalyticsEvent(rawEvent, properties);
  posthog.capture(event, normalizedProperties);
  return event;
};

export const trackEvent = (event: string, properties: AnalyticsProperties = {}) => {
  splitbee.track(event);
  return normalizeAndCapture(event, properties);
};

/** @deprecated Prefer trackEvent with snake_case event names from analyticsEvents.ts */
export const logEvent = (event: string) => {
  trackEvent(event);
};

/** @deprecated Prefer trackEvent with snake_case event names from analyticsEvents.ts */
export const logEventWithProperties = (event: string, properties: AnalyticsProperties) => {
  trackEvent(event, properties || {});
};

export const identifyUser = (
  userId: string,
  traits: AnalyticsProperties = {}
) => {
  if (!userId) return;
  posthog.identify(userId, traits);
};

export const resetAnalyticsUser = () => {
  posthog.reset();
};

export const trackPageView = (path?: string) => {
  const properties: AnalyticsProperties = {};
  if (typeof window !== "undefined") {
    properties.path = path || window.location.pathname;
    properties.search = window.location.search;
    properties.hash = window.location.hash;
  }
  trackEvent("$pageview", properties);
};

export default () => {
  return null;
};
